import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const CustomerGroupForm = () => {
  const [name, setName] = useState('');
  const [discount, setDiscount] = useState('');
  const [description, setDescription] = useState('');
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  // Edit-States
  const [editingId, setEditingId] = useState(null);
  const [editedName, setEditedName] = useState('');
  const [editedDiscount, setEditedDiscount] = useState('');
  const [editedDescription, setEditedDescription] = useState('');

  const fetchGroups = async () => {
    try {
      const res = await api.get('/customerGroups');
      setGroups(res.data);
    } catch {
      alert('Fehler beim Laden der Gruppen');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchGroups(); }, []);

  // Hinzufügen
  const handleAdd = async () => {
    if (!name) return alert('Bitte Name eingeben!');
    try {
      await api.post('/customerGroups', { name, discount, description });
      setName('');
      setDiscount('');
      setDescription('');
      fetchGroups();
    } catch {
      alert('Fehler beim Anlegen');
    }
  };

  // Löschen
  const handleDelete = async id => {
    if (!window.confirm('Wirklich löschen?')) return;
    try {
      await api.delete(`/customerGroups/${id}`);
      setGroups(groups.filter(g => g.id !== id));
    } catch {
      alert('Fehler beim Löschen');
    }
  };

  // Edit starten
  const handleEdit = group => {
    setEditingId(group.id);
    setEditedName(group.name);
    setEditedDiscount(group.discount !== undefined ? group.discount : '');
    setEditedDescription(group.description || '');
  };

  // Edit abbrechen
  const handleCancelEdit = () => {
    setEditingId(null);
    setEditedName('');
    setEditedDiscount('');
    setEditedDescription('');
  };

  // Edit speichern
  const handleUpdate = async id => {
    try {
      await api.put(`/customerGroups/${id}`, {
        name: editedName,
        discount: editedDiscount,
        description: editedDescription
      });
      setEditingId(null);
      fetchGroups();
    } catch {
      alert('Fehler beim Aktualisieren');
    }
  };

  if (loading) return <div>Daten werden geladen...</div>;

  return (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
      <div style={{ width: '700px' }}>
        <Helmet>
          <title>Kundengruppen verwalten</title>
        </Helmet>
        <h2 style={{ textAlign: 'center', marginBottom: 20 }}>Kundengruppen verwalten</h2>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr auto', gap: 10, marginBottom: 20 }}>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Name" />
          <input type="number" value={discount} onChange={e => setDiscount(e.target.value)} placeholder="Rabatt (%)" min="0" max="100" />
          <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Beschreibung" />
          <button onClick={handleAdd} style={{ background: '#28a745', color: '#fff', borderRadius: 4 }}>Hinzufügen</button>
        </div>

        <ul style={{ listStyle: 'none', padding: 0 }}>
          {groups.map(group => (
            <li key={group.id} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 2fr auto', gap: 10, alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #eee' }}>
              {editingId === group.id ? (
                <>
                  <input type="text" value={editedName} onChange={e => setEditedName(e.target.value)} />
                  <input type="number" value={editedDiscount} onChange={e => setEditedDiscount(e.target.value)} placeholder="Rabatt (%)" min="0" max="100" />
                  <input type="text" value={editedDescription} onChange={e => setEditedDescription(e.target.value)} />
                  <div>
                    <button onClick={() => handleUpdate(group.id)} style={{ marginRight: 5 }}>✅</button>
                    <button onClick={handleCancelEdit}>✖️</button>
                  </div>
                </>
              ) : (
                <>
                  <span>{group.name}</span>
                  <span>{group.discount ? `${group.discount}%` : '—'}</span>
                  <span>{group.description}</span>
                  <div>
                    <button onClick={() => handleEdit(group)} style={{ marginRight: 5, background: '#007bff', color: '#fff', borderRadius: 4 }}>Bearbeiten</button>
                    <button onClick={() => handleDelete(group.id)} style={{ background: '#dc3545', color: '#fff', borderRadius: 4 }}>Löschen</button>
                  </div>
                </>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default CustomerGroupForm;
